import React from 'react'
import { ColumnLayout } from '@cloudscape-design/components'
import KpiCard from './KpiCard'

interface KpiItem {
  id: string
  title: string
  value: string | number
  icon?: React.ReactNode
  loading?: boolean
  href?: string
}

interface KpiCardGridProps {
  items: KpiItem[]
  columns?: number
  loading?: boolean
}

export default function KpiCardGrid({ items, columns = 4, loading }: KpiCardGridProps) {
  return (
    <ColumnLayout columns={columns} borders="horizontal">
      {items.map(item => (
        <KpiCard
          key={item.id}
          title={item.title}
          value={item.value}
          icon={item.icon}
          loading={loading || item.loading}
          href={item.href}
        />
      ))}
    </ColumnLayout>
  )
}